import { render, staticRenderFns } from "./OnboardingInviteDeveloper.vue?vue&type=template&id=3070ed3a&scoped=true&lang=pug"
import script from "./OnboardingInviteDeveloper.vue?vue&type=script&lang=ts"
export * from "./OnboardingInviteDeveloper.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingInviteDeveloper.vue?vue&type=style&index=0&id=3070ed3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070ed3a",
  null
  
)

export default component.exports